/* ==========================
OPEN / CLOSE
========================== */

function psgFitOpen(){

document
.getElementById(
'psgFitModal'
)
.classList.add(
'show'
);

const saved =
localStorage.getItem(
'psg_fit_v2_profile'
);

if(!saved) return;

const profile =
JSON.parse(saved);

document.getElementById(
'psgFitHeight'
).value =
profile.height || '';

document.getElementById(
'psgFitWeight'
).value =
profile.weight || '';

document.getElementById(
'psgFitFit'
).value =
profile.fit || 'regular';

}


function psgFitClose(){

document
.getElementById(
'psgFitModal'
)
.classList.remove(
'show'
);

}



/* ==========================
CATEGORY
========================== */

function psgGetCategory(){

const productTitle = (

document.querySelector('h1')
?.innerText ||

''

).toLowerCase();


const tops = [

'top',
'blouse',
'shirt',
'cardigan',
'kimono',
'vest',
'blazer',
'jacket',
'overshirt'

];

const bottoms = [

'trouser',
'trousers',
'pants',
'skirt'

];

const full = [

'dress',
'set',
'prayer'

];


if(
tops.some(
x => productTitle.includes(x)
)
){

return 'top';

}

if(
bottoms.some(
x => productTitle.includes(x)
)
){

return 'bottom';

}

if(
full.some(
x => productTitle.includes(x)
)
){

return 'full';

}

return 'top';

}



/* ==========================
STEP 2
========================== */

function psgFitStep2(){

const category =
psgGetCategory();

const title =
document.querySelector(
'#psgFitStep2 h3'
);

const select =
document.getElementById(
'psgFitDynamicQuestion'
);


if(category === 'bottom'){

title.innerText =
'Tell us about your waist / hips';

select.innerHTML = `

<option value="slim">
Slim
</option>

<option value="average">
Average
</option>

<option value="curvy">
Curvy
</option>

`;

}

else if(category === 'full'){

title.innerText =
'How do you prefer your fit?';

select.innerHTML = `

<option value="regular">
Regular
</option>

<option value="relaxed">
Relaxed
</option>

`;

}

else{

title.innerText =
'Tell us about your shoulders';

select.innerHTML = `

<option value="narrow">
Narrow Shoulders
</option>

<option value="regular">
Regular Shoulders
</option>

<option value="broad">
Broad Shoulders
</option>

`;

}

document
.getElementById(
'psgFitStep1'
)
.style.display='none';

document
.getElementById(
'psgFitStep2'
)
.style.display='block';

}



/* ==========================
AVAILABLE SIZES
========================== */

function psgGetAvailableSizes(){

const sizes = [];

document
.querySelectorAll(
'label,input,.variant-input'
)

.forEach(el=>{

const value = (

el.value ||

el.innerText ||

el.textContent ||

''

)

.trim()

.toUpperCase();


const allowed = [

'S','M','L','XL','XXL',

'S1','S2',

'FREE SIZE',
'ONE SIZE',

'36','38','40',
'42','44','46','48'

];


if(
allowed.includes(value)
){

sizes.push(value);

}

});

return [...new Set(sizes)];

}



/* ==========================
SIZE MAP
========================== */

function psgMapSize(base){

const available =
psgGetAvailableSizes();

if(
available.includes('FREE SIZE') ||
available.includes('ONE SIZE')
){

return null;

}

const map = {

S:['S','36','S1'],

M:['M','38','40','S1'],

L:['L','42','44','S2'],

XL:['XL','46','S2'],

XXL:['XXL','48','S2']

};

const mapped =
map[base] || [];

for(let size of mapped){

if(
available.includes(size)
){

return size;

}

}

/* fallback */

if(
available.includes('S1')
){

return 'S1';

}

if(
available.includes('S2')
){

return 'S2';

}

return available[0] || base;

}



/* ==========================
CALCULATE
========================== */

function psgFitCalculate(){

let weight = parseInt(

document
.getElementById(
'psgFitWeight'
)
.value

);

let fit =

document
.getElementById(
'psgFitFit'
)
.value;


let size='M';


if(weight < 55){

size='S';

}

else if(weight < 70){

size='M';

}

else if(weight < 85){

size='L';

}

else{

size='XL';

}


if(
fit === 'oversized'
){

if(size==='S') size='M';

else if(size==='M') size='L';

else if(size==='L') size='XL';

}


size =
psgMapSize(
size
);


document
.getElementById(
'psgFitFinalSize'
)
.innerText=size;


const profile = {

size:size,

height:
document.getElementById(
'psgFitHeight'
).value,

weight:
document.getElementById(
'psgFitWeight'
).value,

fit:
fit

};


localStorage.setItem(

'psg_fit_v2_profile',

JSON.stringify(
profile
)

);


document
.getElementById(
'psgFitStep2'
)
.style.display='none';


document
.getElementById(
'psgFitResult'
)
.style.display='block';

}



/* ==========================
SAVE SIZE
========================== */

function psgFitSave(){

const size =

document
.getElementById(
'psgFitFinalSize'
)
.innerText;


document
.querySelectorAll(
'label,input'
)

.forEach(el=>{

const value = (

el.value ||

el.innerText ||

''

)

.trim()

.toUpperCase();


if(
value === size
){

el.click?.();

}

});


const title =
document.querySelector(
'.psg-fit-v2-left strong'
);

const sub =
document.querySelector(
'.psg-fit-v2-left p'
);

if(title){

title.innerText =
'Recommended: ' +
size;

}

if(sub){

sub.innerText =
'Tap to reuse previous size';

}

psgFitClose();

}



/* ==========================
ON LOAD
========================== */

document.addEventListener(

'DOMContentLoaded',

()=>{

const sizes =
psgGetAvailableSizes();

if(

sizes.includes(
'FREE SIZE'
)

||

sizes.includes(
'ONE SIZE'
)

){

document
.querySelector(
'.psg-fit-v2-wrapper'
)
?.remove();

}


const saved =
localStorage.getItem(
'psg_fit_v2_profile'
);

if(!saved) return;

const profile =
JSON.parse(saved);

const title =
document.querySelector(
'.psg-fit-v2-left strong'
);

const sub =
document.querySelector(
'.psg-fit-v2-left p'
);

if(title){

title.innerText =
'Recommended: ' +
profile.size;

}

if(sub){

sub.innerText =
'Tap to reuse previous size';

}

});